module.exports = __webpack_public_path__ + "static/media/camera.27e666dc.svg";